export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
